import React from 'react'
import { create } from 'zustand'
import useSWR from 'swr'
import {
  getCoreRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table'
import { Card, CardContent } from '@/components/ui/card'
import Loader from '@/components/ui/Loader'
import EmptyDatas from 'components/ui/EmptyDatas'
import Table from 'components/ui/my-data-table'
import { columns } from './data-table-column'
import DataTableToolbar from './data-table-toolbar'
import {
  TEMP_SPINE_ZIPS_PAGE_LIMIT,
  type TempSpineZip,
  type TempSpineZipsFormState,
} from './types'

export const useForm = create<TempSpineZipsFormState>((set) => ({
  after: null,
  afters: [],
  goAfter: (nextAfter) =>
    set((state) => {
      if (nextAfter === null) {
        return { after: null }
      }
      const index = state.afters.findIndex((a) => a === nextAfter)
      if (index === -1) {
        return { after: nextAfter, afters: [...state.afters, nextAfter] }
      }
      return { after: nextAfter }
    }),
}))

const TempSpineZips: React.FC = () => {
  const params = useForm((s) => ({
    after: s.after,
    limit: TEMP_SPINE_ZIPS_PAGE_LIMIT,
  }))
  const { data, isLoading, isValidating, mutate } = useSWR<TempSpineZip[]>([
    '/ops-tools/temp-spine-zips',
    params,
  ])
  // 与 Notifications 等 Comm 列表一致：有数据则展示 Next，由服务端 cursor 决定是否还有下一页
  const nextAfter = data?.[data.length - 1]?.id

  const table = useReactTable({
    data: data ?? [],
    columns,
    enableRowSelection: false,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    meta: { mutate },
  })

  if (isLoading || isValidating) return <Loader />
  if (!data) return <EmptyDatas />

  return (
    <>
      <DataTableToolbar mutate={mutate} nextAfter={nextAfter} />
      <Card>
        <CardContent>
          <Table table={table} />
        </CardContent>
      </Card>
    </>
  )
}

export default TempSpineZips
